import { AxiosError, isAxiosError } from 'axios';

import legitimizerAPI from '../api';
import { KycProcess } from '../types';

const isServerError = (error: AxiosError) => !!error.response && error.response.status >= 500;
const isNetworkError = (error: AxiosError) => !error.response;

const handleError = (error: unknown) => {
  if (isAxiosError(error) && (isServerError(error) || isNetworkError(error))) {
    // Ignore network errors and server errors, and behave like no KYC process is open.
    // Otherwise the error would prevent all users from accessing Merchant Admin
    return null;
  }
  throw error;
};

export const getLatestKycProcess = (): Promise<KycProcess | null> => {
  const requestURL = 'api/v1/kyc/processes/latest?profile=default';
  return legitimizerAPI
    .get<KycProcess>(requestURL)
    .then(response => response.data)
    .catch(handleError);
};
